import React, { useEffect } from "react";
const Toast = ({ message,title,onClose,image }) => {
    useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);
  if (!message) return null;
  return (
    <div className="toast">
      <div className="toast_header">
      <img src={image}/>
      <div className="toast_title">{title}</div>
      <div className ="toast_close"onClick={onClose}>X</div>
      </div>
      <div className="total_text">
      {message}
      </div>
    </div>
  );
};
 
export default Toast;
 
 